import React, { useEffect, useState } from "react";

const Ellipsis: React.FC = () => {
  const [ellipsisLength, setEllipsisLength] = useState(0);
  const MAX_ELIPSIS_LENGTH = 3;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setEllipsisLength((prev) => (prev === MAX_ELIPSIS_LENGTH ? 0 : prev + 1));
    }, 250);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <span
      style={{
        display: "inline-block",
        width: `${MAX_ELIPSIS_LENGTH * 0.6}em`,
        textAlign: "left",
      }}
    >
      {Array.from({ length: ellipsisLength }, (_, i) => (
        <span key={i}>.</span>
      ))}
    </span>
  );
};

export default Ellipsis;
